import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

import { doc, getDoc } from 'firebase/firestore'
import { db } from '../../lib/firebase'
import RoyalLogo from '../RoyalLogo'

const baseNavigation = [
  { name: 'Inicio', href: '/' },
  { name: 'Servicios', href: '/servicios' },
  { name: 'Casos', href: '/casos' },
  { name: 'Blog', href: '/blog', key: 'showBlog' },
  { name: 'Equipo', href: '/equipo', key: 'showEquipo' },
  { name: 'Contacto', href: '/contacto' },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()
  const [menuConfig, setMenuConfig] = useState({ showBlog: true, showEquipo: true })

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const ref = doc(db, 'ajustes', 'menu')
        const snap = await getDoc(ref)
        if (snap.exists()) {
          setMenuConfig(snap.data())
        }
      } catch (err) {
        console.error('[Header] Error al cargar ajustes:', err)
      }
    }
    fetchConfig()
  }, [])

  // Filtrar navegación según ajustes
  const navigation = baseNavigation.filter(item => {
    if (item.key === 'showBlog' && !menuConfig.showBlog) return false
    if (item.key === 'showEquipo' && !menuConfig.showEquipo) return false
    return true
  })

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <nav className="header-nav">
        {/* Logo */}
        <div className="flex lg:flex-1">
          <Link to="/" className="header-logo">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center space-x-3"
            >

              <RoyalLogo size="md" showParticles />
              <span className="header-logo-text font-bold text-lg">Royal Software</span>
            </motion.div>
          </Link>
        </div>

        {/* Mobile menu button */}
        <div className="flex lg:hidden">
          <button
            type="button"
            className="header-mobile-menu-button"
            onClick={() => setMobileMenuOpen(true)}
          >
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>

        {/* Desktop Navigation */}
        <div className="header-nav-desktop">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`header-nav-link ${
                location.pathname === item.href ? 'active' : ''
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* CTA Button */}
        <div className="header-cta">
          <Link
            to="/contacto"
            className="header-cta-button"
          >
            Hablar con un asesor
          </Link>
        </div>
      </nav>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="lg:hidden fixed inset-0 z-50"
          >
            <div className="header-mobile-menu">
              <div className="header-mobile-menu-header">
                <Link to="/" className="header-logo">
                  <div className="flex items-center space-x-3">
                    <RoyalLogo size="md" showParticles={false} />
                    <span className="header-logo-text font-bold text-lg">Royal Software</span>
                  </div>
                </Link>
                <button
                  type="button"
                  className="header-mobile-menu-close"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="mt-6 flow-root">
                <div className="-my-6 divide-y divide-gray-500/10">
                  <div className="header-mobile-nav">
                    {navigation.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className={`header-mobile-nav-link ${
                          location.pathname === item.href ? 'active' : ''
                        }`}
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                  <div className="header-mobile-cta">
                    <Link
                      to="/contacto"
                      className="header-mobile-cta-button"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Hablar con un asesor
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  )
}
